/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ModelApiResponse
 */
export interface ModelApiResponse {
  /**
   *
   * @type {boolean}
   * @memberof ModelApiResponse
   */
  success: boolean
  /**
   *
   * @type {string}
   * @memberof ModelApiResponse
   */
  errorMessage?: string
  /**
   *
   * @type {number}
   * @memberof ModelApiResponse
   */
  codeError?: number
}

/**
 * Check if a given object implements the ModelApiResponse interface.
 */
export function instanceOfModelApiResponse(
  value: object,
): value is ModelApiResponse {
  if (!('success' in value) || value['success'] === undefined) return false
  return true
}

export function ModelApiResponseFromJSON(json: any): ModelApiResponse {
  return ModelApiResponseFromJSONTyped(json, false)
}

export function ModelApiResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ModelApiResponse {
  if (json == null) {
    return json
  }
  return {
    success: json['success'],
    errorMessage:
      json['errorMessage'] == null ? undefined : json['errorMessage'],
    codeError: json['codeError'] == null ? undefined : json['codeError'],
  }
}

export function ModelApiResponseToJSON(json: any): ModelApiResponse {
  return ModelApiResponseToJSONTyped(json, false)
}

export function ModelApiResponseToJSONTyped(
  value?: ModelApiResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    success: value['success'],
    errorMessage: value['errorMessage'],
    codeError: value['codeError'],
  }
}
